module.exports = __webpack_public_path__ + "static/img/14.74254d29.png";